import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
import { FC } from 'react';
import Box from 'yoda-ui/components/Box';
import { YodaBoxShadow, YodaColors, YodaSpacing } from 'yoda-ui/yodaTheme';

type AppBarProps = MuiAppBarProps;

export const appBarStyle = {
  '&.MuiAppBar-colorDefault': {
    backgroundColor: YodaColors.white,
    boxShadow: YodaBoxShadow.medium,
  },
  '.MuiToolbar-root.MuiToolbar-regular': {
    minHeight: '48px',
  },
};

const AppBar: FC<AppBarProps> = ({ children, ...props }) => (
  <MuiAppBar
    position="static"
    color="default"
    elevation={ 0 }
    sx={ appBarStyle }
    { ...props }
  >
    <Box paddingX={ YodaSpacing.medium } paddingY={ '13px' }>
      { children }
    </Box>
  </MuiAppBar>
);

export default AppBar;
